import { Box, Typography } from '@material-ui/core'
import { Auth } from 'api/index'
import { userActions } from 'ducks/actions'
import React from 'react'
import { useAppDispatch } from 'ducks/hooks'
import { toast } from 'react-toastify'
import { icons } from '../../../../../assets'
import useStyles from './styles'

type Props = {}

const ResetPassword = (props: Props) => {

    const [password, setPassword] = React.useState('')
    const [showPassword, setShowPassword] = React.useState(false)
    const [confirmPassword, setConfirmPassword] = React.useState('')
    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false)
    const userInfo = Auth.getUserInfo()
    const userAuth0Id = userInfo?.sub;
    const classes = useStyles()
    const dispatch = useAppDispatch()

    const passwordAreEqual = password && confirmPassword && password === confirmPassword;
    const handleSubmitChangePassword = () => {
        if (passwordAreEqual && userAuth0Id) {
            dispatch(userActions.resetPasswordRequest({
                params: { userId: userAuth0Id, password: password }, callback: (succ) => {
                    if (succ) {
                        setPassword('')
                        setConfirmPassword('')
                        toast.success("Password reset successfully!")
                    } else {
                        toast.error("Error trying to reset password")
                    }
                }
            }, (succ) => {
                if (succ) {
                    toast.success("Password reset successfully!")
                } else {
                    toast.error("Error trying to reset password")
                }
            }))
        }
    }

    return (
        <Box className={classes.newPasswordContainer}>
            <Typography className={classes.titlePayments}>Reset Password</Typography>
            <Typography className={classes.subtitle}>
                Changing your password will close the sessions in other devices.
            </Typography>
            <div className={classes.inputContainer}>
                <Typography className={classes.inputLabel}>
                    New Password
                </Typography>
                <div style={{ position: "relative" }}>
                    <input
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        type={showPassword ? "text" : "password"}
                        className={classes.input}
                    />
                    <div onClick={() => setShowPassword((prevPass) => !prevPass)} className={classes.eyePassword}>
                        {showPassword ? <icons.VisibilityOff /> : <icons.Visibility />}
                    </div>
                </div>
            </div>
            <div className={`${classes.inputContainer}`}>
                <Typography className={classes.inputLabel}>
                    Confirm New Password
                </Typography>
                <div style={{ position: "relative" }}>
                    <input
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        type={showConfirmPassword ? "text" : "password"}
                        className={`${classes.input}  ${passwordAreEqual ? classes.passwordOk : ''}`}
                    />
                    <div onClick={() => setShowConfirmPassword((prevPass) => !prevPass)} className={classes.eyePassword}>
                        {passwordAreEqual ? <icons.CheckCircle style={{ fill: "#01AA59" }} /> : showConfirmPassword ? <icons.VisibilityOff /> : <icons.Visibility />}
                    </div>
                </div>
            </div>
            <div onClick={handleSubmitChangePassword} className={`${classes.button} ${passwordAreEqual ? "" : classes.buttonDisabled}`}>
                <p className={classes.buttonText}>Reset Password</p>
            </div>
        </Box>
    )
}

export default ResetPassword